import { render, staticRenderFns } from "./productreport.vue?vue&type=template&id=4b0a349c&scoped=true&"
import script from "./productreport.vue?vue&type=script&lang=js&"
export * from "./productreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0a349c",
  null
  
)

export default component.exports